export default __webpack_public_path__ + "static/media/day_planner.b38bd233.png";